/**
 * @generated SignedSource<<2792c6bb12caa73c8e12008719c7617a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AppTabMenu_container$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TabWithMenu_container">;
  readonly " $fragmentType": "AppTabMenu_container";
};
export type AppTabMenu_container$key = {
  readonly " $data"?: AppTabMenu_container$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppTabMenu_container">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "AppTabMenu_container",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TabWithMenu_container"
    }
  ],
  "type": "JiraContainerNavigationResult",
  "abstractKey": "__isJiraContainerNavigationResult"
};

(node as any).hash = "687af9e59bccecfe4646886b7021170f";

export default node;
